import { message, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  InputNumberItem,
  DatePickerItem,
  ErrorItem,
  SelectItem,
  SelectPeriocidadSatItem
} from "../../../../Components/Items";
import moment from "moment";

const { Option } = Select;

class AgregarTipoPeriodo extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
    diasPeriodo: null,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible, diasPeriodo: null });
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onDiasPeriodoChange(value) {
    this.setState({ diasPeriodo: value });
    // Limpiar campos que queden fuera del nuevo rango
    const current = this.formRef.current;
    if (!current) return;
    const diaDePago = current.getFieldValue("diaDePago");
    const posisionSeptimoDia = current.getFieldValue("posisionSeptimoDia");
    if (diaDePago && diaDePago > value) {
      current.setFieldsValue({ diaDePago: undefined });
    }
    if (posisionSeptimoDia && posisionSeptimoDia.length > 0) {
      const filtrados = posisionSeptimoDia.filter((d) => d <= value);
      current.setFieldsValue({ posisionSeptimoDia: filtrados });
    }
  }

  onFinish(values) {
    if (!values?.nombre) {
      return message.info("Proporcione al menos el nombre del tipo de periodo");
    }
    this.setState({ loading: true });
    axios
      .post(
        "tiposPeriodos/agregarTipoPeriodo",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Tipo de periodo agregado exitosamente");
          this.cerrarModal();
        } else if (res.data.success === 1) {
          message.error("No se pudo agregar el tipo de periodo");
        } else {
          message.error("Sucedió un error y no se pudo agregar el tipo de periodo");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  cerrarModal = () => {
    this.setState({ visible: false, diasPeriodo: null });
    this.props.cerrarAgregarTipoPeriodo();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    const { diasPeriodo } = this.state;

    const opcionesDias = diasPeriodo
      ? Array.from({ length: diasPeriodo }, (_, i) => i + 1)
      : [];

    return (
      <ModalItem
        title="Agregar Tipo de Periodo"
        visible={this.state.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={700}
      >
        <Form
          ref={this.formRef}
          name="modalAgregarTipoPeriodo"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem name="nombre" label="Nombre" required margin>
            <InputItem placeholder="Ingresa el nombre del tipo de periodo" />
          </FormItem>

          <FormItem name="fechaInicioEjercicio" label="Fecha Inicio de Ejercicio" required margin initialValue={moment().startOf('year')}>
            <DatePickerItem placeholder="Selecciona la fecha de inicio" style={{ width: "100%" }} />
          </FormItem>

          <FormItem name="diasPeriodo" label="Días del Periodo" required margin>
            <InputNumberItem
              placeholder="Ej. 15"
              min={1}
              onChange={this.onDiasPeriodoChange.bind(this)}
            />
          </FormItem>

          <FormItem name="diasDePago" label="Días de Pago" required margin>
            <InputNumberItem placeholder="Ej. 15" min={1} />
          </FormItem>

          <FormItem name="periodoTrabajo" label="Periodo de Trabajo" required margin>
            <InputNumberItem placeholder="Ej. 14" min={1} />
          </FormItem>

          <FormItem name="ajustarMes" label="Ajustar Mes" margin>
            <SelectItem placeholder="Selecciona una opción">
              <Option value={1}>Sí</Option>
              <Option value={2}>No</Option>
            </SelectItem>
          </FormItem>

          <FormItem name="ajusteDiasPagados" label="Ajuste Días Pagados" margin>
            <SelectItem placeholder="Selecciona el tipo de ajuste">
              <Option value={1}>Días pagados, contando días laborados</Option>
              <Option value={2}>Días pagados, contando días calendario</Option>
            </SelectItem>
          </FormItem>

          <FormItem
            name="posisionSeptimoDia"
            label="Posición Séptimo Día"
            margin
            tooltip={!diasPeriodo ? "Primero ingresa los días del periodo" : undefined}
          >
            <SelectItem
              mode="multiple"
              placeholder={
                diasPeriodo
                  ? `Selecciona días (1 - ${diasPeriodo})`
                  : "Ingresa primero los días del periodo"
              }
              disabled={!diasPeriodo}
            >
              {opcionesDias.map((dia) => (
                <Option key={dia} value={dia}>
                  Día {dia}
                </Option>
              ))}
            </SelectItem>
          </FormItem>

          <FormItem
            name="diaDePago"
            label="Posición Día de Pago"
            margin
            tooltip={!diasPeriodo ? "Primero ingresa los días del periodo" : undefined}
          >
            <SelectItem
              placeholder={
                diasPeriodo
                  ? `Selecciona un día (1 - ${diasPeriodo})`
                  : "Ingresa primero los días del periodo"
              }
              disabled={!diasPeriodo}
            >
              {opcionesDias.map((dia) => (
                <Option key={dia} value={dia}>
                  Día {dia}
                </Option>
              ))}
            </SelectItem>
          </FormItem>

          <FormItem name="periodicidadPagoSatId" label="Periodicidad de Pago SAT" required margin>
            <SelectPeriocidadSatItem
              placeholder="Selecciona la periodicidad SAT"
              headersToken={this.props.headersToken}
            />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AgregarTipoPeriodo);